import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import TimeApprovals from "./TimeApprovals";
import usePageName from "../../../hocs/usePageName";

const TimeApprovalsPage = () => {
  usePageName({
    heading: `Weekly Time Summaries`,
    caption: null,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return (
    <Box>
      <TimeApprovals search={search} status={status ?? "ALL"} />
    </Box>
  );
};

export default TimeApprovalsPage;
